/**
 * 格式化相关常量
 */

/** 空值占位符 */
export const EMPTY_PLACEHOLDER = '--';
